module.exports = __webpack_public_path__ + "static/fgw-f9c489450d1baaf6a9219d5fe6ca90c7.png";